import React from 'react';
import { Box } from '@mui/material';
import { JsonViewer } from '@textea/json-viewer';

/**
 * JsonViewer component displays formatted JSON data with syntax highlighting
 * and collapsible structure.
 * 
 * @param {Object} props - Component props
 * @param {Object|string} props.data - JSON data to display (can be object or string)
 * @returns {JSX.Element} - JsonViewer component
 */
const JsonViewerComponent = ({ data }) => {
  // Parse the data if it's a string
  const jsonData = typeof data === 'string' ? JSON.parse(data) : data;
  
  return (
    <Box 
      sx={{ 
        m: 0, 
        p: 1, 
        fontSize: '0.875rem', 
        fontFamily: 'monospace',
        overflowX: 'auto',
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
        borderRadius: 1,
        maxHeight: '300px',
        overflowY: 'auto'
      }}
    >
      <JsonViewer 
        value={jsonData}
        defaultInspectDepth={1}
        rootName={false}
        displayDataTypes={false}
        displaySize={false}
        enableClipboard={false}
        style={{
          background: 'transparent',
          fontSize: '0.875rem',
        }}
      />
    </Box>
  );
};

export default JsonViewerComponent;
